import React from 'react';
import PropTypes from 'prop-types';
import { IsLoggedIn } from './Auth';
import { router } from '../routes';

class AuthRedirect extends React.Component {

  checkForChanges(){
    if (this.props.whenLoggedOut && !this.props.isLoggedIn) {
      router.navigate({ name: this.props.path });
    }

    if (this.props.whenLoggedIn && this.props.isLoggedIn) {
      router.navigate({ name: this.props.path });
    }
  }

  componentDidMount() {
    this.checkForChanges();
  }

  componentDidUpdate() {
    this.checkForChanges();
  }

  render() {
    return null;
  }
}

AuthRedirect.propTypes = {
  whenLoggedIn: PropTypes.bool,
  whenLoggedOut:PropTypes.bool,
  path: PropTypes.string.isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
};

export default (props) => (
  <IsLoggedIn>
  {(isLoggedIn) => (
    <AuthRedirect isLoggedIn={isLoggedIn} {...props}/>
  )}
  </IsLoggedIn>
)



// WEBPACK FOOTER //
// ./src/auth/AuthRedirect.js